import React from 'react';
import { Button } from '@cokitchen/cokitchen-components';

const RestoreDeleteRiderFooter = ({
  onCancel,
  onConfirm,
  loading
}: {
  onCancel: () => void;
  loading: boolean;
  onConfirm: () => void;
}) => {
  return (
    <div className='grid grid-cols-2 gap-x-4'>
      <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
        Cancel
      </Button>
      <Button
        small
        color='primary'
        variant='block'
        className='mx-auto'
        loading={loading}
        onClick={onConfirm}>
        Confirm
      </Button>
    </div>
  );
};

export default RestoreDeleteRiderFooter;
